import { useQuery } from "@tanstack/react-query";
import MarketOverview from "../components/MarketOverview";
import HomeHero from "./home/HomeHero";
import HomeSaleSection from "./home/HomeSaleSection";
import HomeCompanyFsExtractSection from "./home/HomeCompanyFsExtractSection";
import HomeCategorySection from "./home/HomeCategorySection";
import HomeInsiderNewsSection from "./home/HomeInsiderNewsSection";
import { getWebMainSecondSection, useWebMainFirstQuery } from "../apis/WebMain";
import {AdUnit} from "../components/AdComponent";

export default function Home() {
  const homeFirstQuery = useWebMainFirstQuery();

  const firstLoad = homeFirstQuery.isFetched;
  const investors = homeFirstQuery.data?.investors || [];
  const curations = homeFirstQuery.data?.curations || [];

  const tickers = curations
    .filter((item) => item.seltype === "recentEarn")
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 6)

  const companyMetaByTicker = tickers.reduce((acc, item) => {
    const ticker = item?.ticker;

    if (!ticker || acc[ticker]) {
      return acc;
    }

    acc[ticker] = {
      companyKor: item?.companyKor || "",
      company: item?.company || "",
      nickname: item?.nickname || "",
    };
    return acc;
  }, {});

  // 최근 실적 소식 섹션을 위한 티커 추출
  const ticker_params = curations
    .filter((item) => item.seltype === "recentEarn")
    .sort((a, b) => a.rank - b.rank)
    .slice(0, 6)
    .map((item) => item.ticker)
    .join(", ");


  const homeSecondQuery = useQuery({
    queryKey: ["webMain", "second"],
    queryFn: () => getWebMainSecondSection(ticker_params),
    enabled: homeFirstQuery.isSuccess,
  });

  const secondLoad = homeSecondQuery.isFetched;
  const companyFsExtracts = homeSecondQuery.data?.companyfsextracts || [];
  const companyNews = homeSecondQuery.data?.companynews || [];
  return (
    <>
      <MarketOverview curations={curations} />
      <div className="home-page">
        <div className="home-page-frame p-3 p-lg-4">
          <aside className="home-page-side home-page-side-left" aria-hidden="true">
            <AdUnit key="6618037988" slot="6618037988" style={{}}/>
          </aside>
          <div className="home-page-content">
            <div className="home-dashboard">
              {firstLoad && investors ? (
                <HomeHero
                  data={investors}
                />
              ) : null}

              {firstLoad && curations ? (
                <HomeSaleSection
                  data={curations}
                />
              ) : null}

              {secondLoad ? (
                <>
                  {
                    <HomeCompanyFsExtractSection
                      data={companyFsExtracts}
                      companyMetaByTicker={companyMetaByTicker}
                    />
                  }
                  {
                    <HomeInsiderNewsSection
                      data={curations}
                    />
                  }
                  {
                    <HomeCategorySection data={companyNews} />
                  }
                </>
              ) : null}
            </div>
          </div>
          <aside className="home-page-side home-page-side-right" aria-hidden="true">
              <AdUnit key="1469829723" slot="1469829723" style={{}}/>
          </aside>
        </div>
        <div className="d-flex justify-content-center my-4">
          <div style={{ width: '100%', maxWidth: '970px' }}>
            <AdUnit key="5376743544" slot="5376743544" />
          </div>
        </div>
      </div>
    </>
  );
}
